import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import "./dashboard.scss";
import Accordion from "react-bootstrap/Accordion";
import { Navigate, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import CreateAgent from "./DashboardComponents/Agents/createAgent";
import WelcomeScreen from "./DashboardComponents/welcomeScreen";
import KnowledgeBasis from "./DashboardComponents/KnowledgeBasis/KnowledgeBasis";
import Dialer from "./DashboardComponents/Dialer/Dialer";
import Setting from "./DashboardComponents/Setting/Setting";
import OwnAgents from "./DashboardComponents/OwnAgents/ownAgents";
import OldDialer from "./DashboardComponents/Dialer/OldDialer";
import WholeLoader from "./WholeLoader";
import NewDialer from "./DashboardComponents/Dialer/NewDialer";
import axios from "axios";

const Dashboard = () => {
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    if (!authToken) {
      navigate("/login");
    } else {
      //   var email = JSON.parse(localStorage.getItem("email"));
      //   if (email === "admin@gmail.com") {
      //     navigate("/dashboard");
      //   } else {
      //     navigate("/singleagent");
      //   }
    }
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowLoader(false);
    }, 3000);

    getProfile();

    return () => clearTimeout(timeoutId);
  }, []);

  const getProfile = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}/customer/profile`;
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      axios
        .get(apiUrl, config)
        .then((response) => {
          console.log("profile data", response.data);
          localStorage.setItem("phone", JSON.stringify(response?.data?.phone));
          localStorage.setItem(
            "name",
            JSON.stringify(response?.data?.userName)
          );
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [isActive, setIsActive] = useState("tab1");
  const toggleSidebar = () => {
    setIsActive(!isActive);
  };
  const [activeTab, setActiveTab] = useState("tab1");
  const [mobileWidth, setMobileWidth] = useState(0);
  //console.log("the tab is:", activeTab);
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const [isVisible, setIsVisible] = useState(true);
  const handleDrawer = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    const handleResize = () => {
      setMobileWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setIsVisible(mobileWidth && mobileWidth >= 1200);
  }, [mobileWidth]);

  const [openAccordion, setOpenAccordion] = useState(null);
  const toggleAccordion = (eventKey) => {
    if (openAccordion === eventKey) {
      setOpenAccordion(null);
    } else {
      setOpenAccordion(eventKey);
    }
  };

  const isAccordionOpen = (eventKey) => {
    return openAccordion === eventKey;
  };
  if (activeTab === "tab32") {
    Navigate("/goal");
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebarLeft = (event) => {
    event.stopPropagation();
    setIsSidebarOpen((prev) => !prev);
  };

  /* SideBar Closed Click start */
  const dropdownRef = useRef(null);
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  /* SideBar Closed Click End */

  return (
    <>
      {/* <div className="dashboardWrapper"> */}
      {/* <div className="dashboard-left-content"> */}
      <section className="dashboard">
        <Icon
          icon="iconamoon:menu-burger-horizontal"
          className="burger-Icon"
          onClick={(event) => toggleSidebarLeft(event)}
        />
        {/* <div className="dashboard-left-content"{`sidebar ${isSidebarOpen ? 'open' : ''}`}> */}
        <div
          className={`dashboard-left-content sidebar ${
            isSidebarOpen ? "open" : ""
          }`}
          ref={dropdownRef}
        >
          <ul>
            <p className="tools">Tools</p>
            <div
              className={`dashboardLink ${
                activeTab === "tab1" ? "active" : ""
              }`}
              onClick={(event) => {
                toggleSidebarLeft(event);
                handleTabChange("tab1");
                toggleSidebar();
              }}
            >
              <Icon
                className="iconsdash"
                icon="material-symbols:database-outline"
                color="white"
                width="32"
                height="32"
              />
              <li
                onClick={() => {
                  // handleTabChange("tab1");
                  // toggleSidebar();
                }}
              >
                Dashboard
              </li>
            </div>

            <div
              className={`agentLink ${activeTab === "tab2" ? "active" : ""}`}
              onClick={(event) => {
                toggleSidebarLeft(event);
                handleTabChange("tab2");
                toggleSidebar();
              }}
            >
              <Icon
                className="iconsdash2"
                icon="mdi:account-add-outline"
                color="white"
                width="32"
                height="32"
              />
              <li
                onClick={() => {
                  // handleTabChange("tab2");
                  // toggleSidebar();
                }}
              >
                Agents
              </li>
            </div>

            {/* <div
              className={`docLink ${activeTab === "tab3" ? "active" : ""}`}
              onClick={(event) => {
                toggleSidebarLeft(event);
              }}
            >
              <Icon className="iconsdash" icon="fe:document" color="white" width="24" height="24" />
              <li>Documentation</li>
            </div>

            <div
              className={`knowLink ${activeTab === "tab4" ? "active" : ""}`}
              onClick={(event) => {
                toggleSidebarLeft(event);
                handleTabChange("tab4");
                toggleSidebar();
              }}
            >
              <Icon className="iconsdash" icon="solar:danger-circle-linear" color="white" width="32" height="32" />
              <li
                onClick={() => {
                  // handleTabChange("tab4");
                  // toggleSidebar();
                }}
              >
                Knowledge Basis
              </li>
            </div> */}

            <div
              className={`dialerLink ${activeTab === "tab5" ? "active" : ""}`}
              onClick={(event) => {
                toggleSidebarLeft(event);
                handleTabChange("tab5");
                toggleSidebar();
              }}
            >
              <Icon
                className="iconsdash"
                icon="ph:phone-light"
                color="white"
                width="32"
                height="32"
              />

              <li
                onClick={() => {
                  // handleTabChange("tab5");
                  // toggleSidebar();
                }}
              >
                Dialer
              </li>
            </div>

            <div
              className={`ownagentLink ${activeTab === "tab7" ? "active" : ""}`}
              onClick={(event) => {
                toggleSidebarLeft(event);
                handleTabChange("tab7");
                toggleSidebar();
              }}
            >
              <Icon
                className="iconsdash"
                icon="bx:user"
                color="white"
                width="32"
                height="32"
              />
              <li
                onClick={() => {
                  // handleTabChange("tab7");
                  // toggleSidebar();
                }}
              >
                Own Agents
              </li>
            </div>
          </ul>

          <div
            className={`settingDiv`}
            onClick={(event) => {
              toggleSidebarLeft(event);
              handleTabChange("tab6");
              toggleSidebar();
            }}
          >
            <div
              className={`settingContent ${
                activeTab === "tab6" ? "active" : ""
              }`}
              onClick={() => {
                // handleTabChange("tab6");
                // toggleSidebar();
              }}
            >
              <Icon
                className="settingImg"
                icon="solar:settings-linear"
                color="white"
                width="32"
                height="32"
              />
              <p className="settingText">Settings</p>
            </div>
          </div>
        </div>

        <div className={`right ${!isSidebarOpen ? "open" : ""}`}>
          {activeTab === "tab1" && <WelcomeScreen />}
          {activeTab === "tab2" && <CreateAgent />}
          {activeTab === "tab4" && <KnowledgeBasis />}
          {activeTab === "tab5" && <NewDialer />}
          {activeTab === "tab6" && <Setting />}
          {activeTab === "tab7" && <OwnAgents />}
          {/* {activeTab === "tab5" && <Dialer />} */}
          {/* {activeTab === "tab5" && <OldDialer />} */}
        </div>
      </section>
      {showLoader && <WholeLoader />}
    </>
  );
};

export default Dashboard;
